import { Locale } from '@ps-smart-cp/ppfw-client';

const offBalanceFaControlClassConfig = {
  normalAsset: new Map([[Locale.ja, '通常資産']]),
  unaccountedAsset: new Map([[Locale.ja, '簿外資産']]),
};

export { offBalanceFaControlClassConfig };
